/* eslint-disable consistent-default-export-name/default-export-match-filename -- The wrapper preserves the upstream component name. */
import Original from 'monoai:original?components/PasswordSignInForm/index';
import { type ComponentProps, useMemo } from 'react';

import LastUsedTag from '@/components/LastUsedTag';
import { lastSignInMethod } from '@/utils/last-sign-in-method';

import styles from './last-used.module.scss';

// eslint-disable-next-line react/function-component-definition -- Additive wrappers require function declarations.
export default function PasswordSignInForm(props: ComponentProps<typeof Original>) {
  const lastUsed = useMemo(() => lastSignInMethod() === 'password', []);
  if (!lastUsed) {
    return <Original {...props} />;
  }
  return (
    <div className={styles.lastUsed}>
      <LastUsedTag />
      <Original {...props} />
    </div>
  );
}
/* eslint-enable consistent-default-export-name/default-export-match-filename */
